<p-confirmDialog [style]="{width: '480px'}"></p-confirmDialog>

<div class="stmt-dashboard" *ngIf="data" (click)="closeAllInfo()">
  <div class="dash-header">
    <span class="dash-title">Statement Dashboard</span>
    <span class="dash-period">{{ data.startDate | date:'MMM yyyy' }}</span>
    <span class="dash-meta" *ngIf="data.statusTotal > 0">
      {{ data.statusTotal }} stmts · {{ data.statusPublished }} published ({{ publishedRatio() }})
    </span>
    <span class="dash-meta sep">last regenerated: {{ lastRegenLabel() }}</span>
    <span class="dash-spacer"></span>
    <button pButton type="button" icon="pi pi-question-circle" class="p-button-text p-button-sm help-btn"
            (click)="goToHelp(); $event.stopPropagation()"
            pTooltip="Open the Statement Production Guide (full how-to)" tooltipPosition="left">
      <span class="help-label">How To Guide</span>
    </button>
    <button pButton type="button" icon="pi pi-refresh" class="p-button-text p-button-sm"
            [disabled]="loading || actionInFlight" (click)="fetch(); $event.stopPropagation()"
            pTooltip="Refresh dashboard"></button>
  </div>

  <div class="dash-grid">

    <!-- TILE 1: Reservations Ready to Add -->
    <div class="dash-tile" [ngClass]="reservationsReadyColor()">
      <div class="tile-head">
        <span class="tile-label">Reservations Ready to Add</span>
        <i class="pi pi-info-circle info-icon" (click)="toggleInfo('reservationsReady', $event)"></i>
      </div>
      <div class="tile-value">{{ data.reservationsReadyToAddCount }}</div>
      <div class="tile-sub">across {{ data.reservationsReadyToAddStmts }} statements</div>
      <button *ngIf="data.reservationsReadyToAddCount > 0"
              pButton type="button" label="Regenerate Statements"
              icon="pi pi-sync" class="p-button-sm tile-action"
              [disabled]="actionInFlight"
              (click)="regenerateStatementsAction(); $event.stopPropagation()"></button>
      <div class="info-pop" *ngIf="infoOpen['reservationsReady']" (click)="$event.stopPropagation()">
        <ng-container *ngTemplateOutlet="infoTpl; context: { $implicit: TILE_INFO['reservationsReady'] }"></ng-container>
      </div>
    </div>

    <!-- TILE 2: Expenses Ready to Add -->
    <div class="dash-tile" [ngClass]="expensesReadyColor()">
      <div class="tile-head">
        <span class="tile-label">Expenses Ready to Add</span>
        <i class="pi pi-info-circle info-icon" (click)="toggleInfo('expensesReady', $event)"></i>
      </div>
      <div class="tile-value">{{ data.expensesReadyToAddCount }}</div>
      <div class="tile-sub">${{ data.expensesReadyToAddTotal | number:'1.2-2' }} · {{ data.expensesReadyToAddStmts }} stmts</div>
      <button *ngIf="data.expensesReadyToAddCount > 0"
              pButton type="button" label="Regenerate Expenses"
              icon="pi pi-sync" class="p-button-sm tile-action"
              [disabled]="actionInFlight"
              (click)="regenerateExpensesAction(); $event.stopPropagation()"></button>
      <div class="info-pop" *ngIf="infoOpen['expensesReady']" (click)="$event.stopPropagation()">
        <ng-container *ngTemplateOutlet="infoTpl; context: { $implicit: TILE_INFO['expensesReady'] }"></ng-container>
      </div>
    </div>

    <!-- TILE 3: Expense Blockers -->
    <div class="dash-tile" [ngClass]="blockersColor()">
      <div class="tile-head">
        <span class="tile-label">Expense Blockers</span>
        <i class="pi pi-info-circle info-icon" (click)="toggleInfo('expenseBlockers', $event)"></i>
      </div>
      <div class="tile-value">{{ (data.expenseBlockersNullBilledDate || 0) + (data.expenseBlockersNotReviewed || 0) }}</div>
      <div class="tile-sub">
        <span *ngIf="data.expenseBlockersNullBilledDate > 0">{{ data.expenseBlockersNullBilledDate }} NULL date</span>
        <span *ngIf="data.expenseBlockersNullBilledDate > 0 && data.expenseBlockersNotReviewed > 0"> · </span>
        <span *ngIf="data.expenseBlockersNotReviewed > 0">{{ data.expenseBlockersNotReviewed }} not REVIEWED</span>
        <span *ngIf="(data.expenseBlockersNullBilledDate || 0) + (data.expenseBlockersNotReviewed || 0) === 0">all clear</span>
      </div>
      <div class="tile-actions" *ngIf="(data.expenseBlockersNullBilledDate || 0) + (data.expenseBlockersNotReviewed || 0) > 0">
        <button pButton type="button" label="View List" icon="pi pi-list"
                class="p-button-sm tile-action secondary"
                (click)="openExpenseBlockersDrill(); $event.stopPropagation()"></button>
        <button *ngIf="data.expenseBlockersNotReviewed > 0"
                pButton type="button" label="Bulk Set REVIEWED"
                icon="pi pi-check-square" class="p-button-sm tile-action"
                [disabled]="actionInFlight"
                (click)="bulkSetReviewedAction(); $event.stopPropagation()"></button>
      </div>
      <div class="info-pop" *ngIf="infoOpen['expenseBlockers']" (click)="$event.stopPropagation()">
        <ng-container *ngTemplateOutlet="infoTpl; context: { $implicit: TILE_INFO['expenseBlockers'] }"></ng-container>
      </div>
    </div>

    <!-- TILE 4: Unlocked Reservations -->
    <div class="dash-tile" [ngClass]="unlockedColor()">
      <div class="tile-head">
        <span class="tile-label">Unlocked Reservations</span>
        <i class="pi pi-info-circle info-icon" (click)="toggleInfo('unlockedLedgers', $event)"></i>
      </div>
      <div class="tile-value">{{ data.unlockedLedgerReservations }}</div>
      <div class="tile-sub">silently excluded from stmts</div>
      <div class="tile-actions" *ngIf="data.unlockedLedgerReservations > 0">
        <button pButton type="button" label="View List" icon="pi pi-list"
                class="p-button-sm tile-action secondary"
                (click)="openUnlockedLedgersDrill(); $event.stopPropagation()"></button>
        <button pButton type="button" label="Lock All in Period"
                icon="pi pi-lock" class="p-button-sm tile-action"
                [disabled]="actionInFlight"
                (click)="lockLedgersAction(); $event.stopPropagation()"></button>
      </div>
      <div class="info-pop" *ngIf="infoOpen['unlockedLedgers']" (click)="$event.stopPropagation()">
        <ng-container *ngTemplateOutlet="infoTpl; context: { $implicit: TILE_INFO['unlockedLedgers'] }"></ng-container>
      </div>
    </div>

    <!-- TILE 5: Cancelled (OX) Awaiting -->
    <div class="dash-tile" [ngClass]="oxColor()">
      <div class="tile-head">
        <span class="tile-label">Cancelled (OX) Awaiting</span>
        <i class="pi pi-info-circle info-icon" (click)="toggleInfo('oxAwaiting', $event)"></i>
      </div>
      <div class="tile-value">{{ data.oxAwaitingManualAdd }}</div>
      <div class="tile-sub">qualifying revenue not on stmts</div>
      <button *ngIf="data.oxAwaitingManualAdd > 0"
              pButton type="button" label="View List" icon="pi pi-list"
              class="p-button-sm tile-action"
              (click)="openQualifyingOxDrill(); $event.stopPropagation()"></button>
      <div class="info-pop" *ngIf="infoOpen['oxAwaiting']" (click)="$event.stopPropagation()">
        <ng-container *ngTemplateOutlet="infoTpl; context: { $implicit: TILE_INFO['oxAwaiting'] }"></ng-container>
      </div>
    </div>

    <!-- TILE 6: Email Progress -->
    <div class="dash-tile" [ngClass]="emailColor()">
      <div class="tile-head">
        <span class="tile-label">Email Progress</span>
        <i class="pi pi-info-circle info-icon" (click)="toggleInfo('email', $event)"></i>
      </div>
      <div class="tile-value">{{ data.emailedCount }} / {{ data.statusPublished }}</div>
      <div class="tile-sub">
        <span *ngIf="data.emailRemaining > 0">{{ data.emailRemaining }} remaining</span>
        <span *ngIf="data.emailRemaining === 0 && data.statusPublished > 0">all sent</span>
        <span *ngIf="data.statusPublished === 0">no published yet</span>
      </div>
      <button *ngIf="data.emailRemaining > 0"
              pButton type="button" label="Show Unemailed"
              icon="pi pi-envelope" class="p-button-sm tile-action"
              (click)="onUnemailedClick(); $event.stopPropagation()"></button>
      <div class="info-pop" *ngIf="infoOpen['email']" (click)="$event.stopPropagation()">
        <ng-container *ngTemplateOutlet="infoTpl; context: { $implicit: TILE_INFO['email'] }"></ng-container>
      </div>
    </div>

    <!-- TILE 7: Payments -->
    <div class="dash-tile" [ngClass]="paymentColor()">
      <div class="tile-head">
        <span class="tile-label">Payments</span>
        <i class="pi pi-info-circle info-icon" (click)="toggleInfo('payments', $event)"></i>
      </div>
      <div class="tile-value">{{ data.payPaid + data.payManualPaid }} paid</div>
      <div class="tile-sub">
        <span *ngIf="data.paySubmitted > 0">{{ data.paySubmitted }} in flight · </span>
        <span *ngIf="data.payQueued > 0">{{ data.payQueued }} queued · </span>
        <span *ngIf="data.payPending > 0">{{ data.payPending }} pending · </span>
        <span *ngIf="data.payReturned > 0" class="warn-text">{{ data.payReturned }} returned · </span>
        <span *ngIf="data.payFailed > 0" class="warn-text">{{ data.payFailed }} failed</span>
        <span *ngIf="data.payNotApplicable > 0">· {{ data.payNotApplicable }} N/A</span>
      </div>
      <button pButton type="button" label="Open NACHA Tools"
              icon="pi pi-money-bill" class="p-button-sm tile-action"
              (click)="goToNacha(); $event.stopPropagation()"></button>
      <div class="info-pop" *ngIf="infoOpen['payments']" (click)="$event.stopPropagation()">
        <ng-container *ngTemplateOutlet="infoTpl; context: { $implicit: TILE_INFO['payments'] }"></ng-container>
      </div>
    </div>

    <!-- TILE: Missing Required Ledger Rows (R8/R9) -->
    <div class="dash-tile" [ngClass]="missingLedgerColor()">
      <div class="tile-head">
        <span class="tile-label">Missing Ledger Rows</span>
        <i class="pi pi-info-circle info-icon" (click)="toggleInfo('missingLedgerRows', $event)"></i>
      </div>
      <div class="tile-value">{{ data.missingLedgerRowsReservations }}</div>
      <div class="tile-sub">missing OWNER_AMOUNT / KBM_MGMT_FEE</div>
      <button *ngIf="data.missingLedgerRowsReservations > 0"
              pButton type="button" label="View List" icon="pi pi-list"
              class="p-button-sm tile-action"
              (click)="openMissingLedgerRowsDrill(); $event.stopPropagation()"></button>
      <div class="info-pop" *ngIf="infoOpen['missingLedgerRows']" (click)="$event.stopPropagation()">
        <ng-container *ngTemplateOutlet="infoTpl; context: { $implicit: TILE_INFO['missingLedgerRows'] }"></ng-container>
      </div>
    </div>

    <!-- TILE: Pending Billing Watchlist (E1) -->
    <div class="dash-tile" [ngClass]="pendingBillingColor()">
      <div class="tile-head">
        <span class="tile-label">Pending Billing</span>
        <i class="pi pi-info-circle info-icon" (click)="toggleInfo('pendingBilling', $event)"></i>
      </div>
      <div class="tile-value">{{ data.pendingBillingNullDate }}</div>
      <div class="tile-sub">
        <span *ngIf="data.pendingBillingNullDate > 0">oldest: {{ data.pendingBillingOldestAgeDays }} days</span>
        <span *ngIf="data.pendingBillingNullDate === 0">no expenses awaiting</span>
      </div>
      <button *ngIf="data.pendingBillingNullDate > 0"
              pButton type="button" label="View List" icon="pi pi-list"
              class="p-button-sm tile-action secondary"
              (click)="openPendingBillingDrill(); $event.stopPropagation()"></button>
      <div class="info-pop" *ngIf="infoOpen['pendingBilling']" (click)="$event.stopPropagation()">
        <ng-container *ngTemplateOutlet="infoTpl; context: { $implicit: TILE_INFO['pendingBilling'] }"></ng-container>
      </div>
    </div>

    <!-- TILE: Last Run Errors (R5/R7/E5 visibility) -->
    <div class="dash-tile" [ngClass]="lastRunErrorsColor()">
      <div class="tile-head">
        <span class="tile-label">Last Run Errors</span>
        <i class="pi pi-info-circle info-icon" (click)="toggleInfo('lastRunErrors', $event)"></i>
      </div>
      <div class="tile-value">
        {{ (data.lastRunPaidNightsZero || 0) + (data.lastRunInvariantR7 || 0) + (data.lastRunExpenseErrors || 0) }}
      </div>
      <div class="tile-sub">
        <span *ngIf="data.lastRunPaidNightsZero > 0">{{ data.lastRunPaidNightsZero }} edge</span>
        <span *ngIf="data.lastRunInvariantR7 > 0" class="warn-text"> · {{ data.lastRunInvariantR7 }} R7</span>
        <span *ngIf="data.lastRunExpenseErrors > 0" class="warn-text"> · {{ data.lastRunExpenseErrors }} expense errors</span>
        <span *ngIf="!data.lastRunPaidNightsZero && !data.lastRunInvariantR7 && !data.lastRunExpenseErrors">clean run</span>
      </div>
      <div class="info-pop" *ngIf="infoOpen['lastRunErrors']" (click)="$event.stopPropagation()">
        <ng-container *ngTemplateOutlet="infoTpl; context: { $implicit: TILE_INFO['lastRunErrors'] }"></ng-container>
      </div>
    </div>

    <!-- TILE 8: NACHA Distribution -->
    <div class="dash-tile" [ngClass]="nachaColor()">
      <div class="tile-head">
        <span class="tile-label">NACHA Distribution</span>
        <i class="pi pi-info-circle info-icon" (click)="toggleInfo('nacha', $event)"></i>
      </div>
      <div class="tile-value">
        <span *ngIf="data.nachaBatchStatus">{{ data.nachaBatchStatus }}</span>
        <span *ngIf="!data.nachaBatchStatus">Not Generated</span>
      </div>
      <div class="tile-sub">
        <span *ngIf="data.nachaBatchId">
          #{{ data.nachaBatchId }} · {{ data.nachaEntryCount }} · ${{ data.nachaTotalAmount | number:'1.2-2' }}
        </span>
        <span *ngIf="!data.nachaBatchId">no batch yet for this period</span>
      </div>
      <button pButton type="button" label="Open NACHA Tools"
              icon="pi pi-cog" class="p-button-sm tile-action"
              (click)="goToNacha(); $event.stopPropagation()"></button>
      <div class="info-pop" *ngIf="infoOpen['nacha']" (click)="$event.stopPropagation()">
        <ng-container *ngTemplateOutlet="infoTpl; context: { $implicit: TILE_INFO['nacha'] }"></ng-container>
      </div>
    </div>

  </div>

  <!-- Pre-Send Checklist -->
  <div class="checklist-section" [class.checklist-open]="checklistOpen">
    <div class="checklist-header" (click)="toggleChecklist()">
      <span class="checklist-title">
        <i class="pi" [ngClass]="checklistAllClear() ? 'pi-check-circle' : 'pi-exclamation-circle'"
           [style.color]="checklistAllClear() ? '#2e7d32' : '#c62828'"></i>
        Pre-Send Checklist
        <span class="checklist-badge" [class.badge-green]="checklistAllClear()" [class.badge-red]="!checklistAllClear()">
          {{ checklistPassCount() }} / {{ checklistItems().length }} passed
        </span>
      </span>
      <span class="checklist-toggle-label" *ngIf="!checklistAllClear()">ACTION REQUIRED</span>
      <span class="checklist-toggle-label green-label" *ngIf="checklistAllClear()">COMPLETE</span>
      <i class="pi" [ngClass]="checklistOpen ? 'pi-chevron-up' : 'pi-chevron-down'" style="margin-left:auto;color:#666;font-size:12px;"></i>
    </div>
    <div class="checklist-body" *ngIf="checklistOpen">
      <table class="checklist-table">
        <thead>
          <tr>
            <th></th>
            <th>Item</th>
            <th>Status</th>
            <th>Pass condition</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of checklistItems()" [class.cl-pass]="item.pass" [class.cl-fail]="!item.pass">
            <td class="cl-icon">
              <i class="pi" [ngClass]="item.pass ? 'pi-check' : 'pi-times'"
                 [style.color]="item.pass ? '#2e7d32' : '#c62828'"></i>
            </td>
            <td class="cl-label" [class.cl-label-fail]="!item.pass">{{ item.label }}</td>
            <td class="cl-value" [class.cl-value-pass]="item.pass" [class.cl-value-fail]="!item.pass">{{ item.value }}</td>
            <td class="cl-detail">{{ item.detail }}</td>
          </tr>
        </tbody>
      </table>
      <div class="checklist-footer">
        <span *ngIf="checklistAllClear()" class="cl-complete-msg">
          All checks passed — statements are ready to send.
        </span>
        <span *ngIf="!checklistAllClear()" class="cl-action-msg">
          {{ checklistItems().length - checklistPassCount() }} item{{ (checklistItems().length - checklistPassCount()) === 1 ? '' : 's' }} still outstanding. Resolve the red items above before mailing statements.
        </span>
      </div>
    </div>
  </div>

  <!-- Status counts row -->
  <div class="dash-status-row" *ngIf="data.statusTotal > 0">
    <span class="status-label">Status:</span>
    <span class="status-pill draft" (click)="onStatusTileClick(1)" *ngIf="data.statusDraft > 0">{{ data.statusDraft }} Draft</span>
    <span class="status-pill need-attn" (click)="onStatusTileClick(2)" *ngIf="data.statusNeedAttention > 0">{{ data.statusNeedAttention }} Need Attention</span>
    <span class="status-pill rfr" (click)="onStatusTileClick(3)" *ngIf="data.statusReadyForReview1 > 0">{{ data.statusReadyForReview1 }} RFR1</span>
    <span class="status-pill rfr" (click)="onStatusTileClick(4)" *ngIf="data.statusReadyForReview2 > 0">{{ data.statusReadyForReview2 }} RFR2</span>
    <span class="status-pill rfr" (click)="onStatusTileClick(5)" *ngIf="data.statusReadyForReview3 > 0">{{ data.statusReadyForReview3 }} RFR3</span>
    <span class="status-pill approved" (click)="onStatusTileClick(6)" *ngIf="data.statusApproved > 0">{{ data.statusApproved }} Approved</span>
    <span class="status-pill published" (click)="onStatusTileClick(7)" *ngIf="data.statusPublished > 0">{{ data.statusPublished }} Published</span>
  </div>
</div>

<div class="stmt-dashboard-loading" *ngIf="loading && !data">
  <i class="pi pi-spin pi-spinner"></i> Loading dashboard...
</div>

<!-- Reusable info popover template -->
<ng-template #infoTpl let-info>
  <div class="info-pop-inner">
    <div class="info-title">{{ info.title }}</div>
    <div class="info-section"><strong>What this means:</strong> {{ info.what }}</div>
    <div class="info-section"><strong>Why this happens:</strong> {{ info.why }}</div>
    <div class="info-section">
      <strong>Colors:</strong>
      <ul>
        <li><span class="dot green"></span> Green: {{ info.greenWhen }}</li>
        <li *ngIf="info.yellowWhen"><span class="dot yellow"></span> Yellow: {{ info.yellowWhen }}</li>
        <li><span class="dot red"></span> Red: {{ info.redWhen }}</li>
      </ul>
    </div>
    <div class="info-section"><strong>What to do:</strong> {{ info.whatToDo }}</div>
    <div class="info-foot">
      <a href="javascript:void(0)" (click)="goToHelp()">Open the full How-To Guide →</a>
    </div>
  </div>
</ng-template>

<!-- Drill-down dialog -->
<p-dialog [(visible)]="drillDialogOpen" [modal]="true" [style]="{width: '85vw', maxWidth: '1100px'}"
          [header]="drillTitle" (onHide)="closeDrill()">
  <div *ngIf="drillLoading && drillRows.length === 0 && !drillError" class="empty-drill">
    <i class="pi pi-spin pi-spinner" style="font-size:1.5rem;margin-right:8px"></i> Loading details…
  </div>
  <div *ngIf="drillError" class="empty-drill" style="color:#c0392b">
    <i class="pi pi-exclamation-triangle" style="margin-right:6px"></i>{{ drillError }}
  </div>
  <div *ngIf="!drillLoading && !drillError && drillRows.length === 0" class="empty-drill" style="color:#27ae60">
    <i class="pi pi-check-circle" style="margin-right:6px"></i>No items found — all clear.
  </div>
  <div *ngIf="drillRows.length > 0" class="drill-content">
    <div class="drill-summary">{{ drillRows.length }} item{{ drillRows.length === 1 ? '' : 's' }}</div>
    <p-table [value]="drillRows" [rows]="20" [paginator]="true" [scrollable]="true" scrollHeight="50vh">
      <ng-template pTemplate="header">
        <tr *ngIf="drillTileKey === 'oxAwaiting'">
          <th>Property</th>
          <th>Conf #</th>
          <th>Check-In</th>
          <th>Check-Out</th>
          <th>Type</th>
          <th style="text-align:right">Net Retained</th>
          <th>Order</th>
          <th style="min-width:220px">Action</th>
        </tr>
        <tr *ngIf="drillTileKey !== 'oxAwaiting'">
          <th *ngFor="let c of drillColumns">{{ c.header }}</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-row>
        <!-- OX-specific row with action buttons -->
        <ng-container *ngIf="drillTileKey === 'oxAwaiting'">
          <tr [style.opacity]="row._state ? '0.65' : '1'">
            <td>{{ row.propertyCode }}</td>
            <td>{{ row.reservationConfId }}</td>
            <td>{{ row.checkInDateFormatted }}</td>
            <td>{{ row.checkOutDateFormatted }}</td>
            <td>{{ row.rezTypeLabel }}</td>
            <td style="text-align:right">{{ row.netRetained | currency:'USD':'symbol':'1.2-2' }}</td>
            <td>
              <a *ngIf="row._orderLink" [routerLink]="row._orderLink" target="_blank"
                 style="color:#1565C0;text-decoration:underline">Order</a>
              <span *ngIf="row._orderLink && row.ownerStmtId" style="margin:0 4px;color:#ccc">|</span>
              <a *ngIf="row.ownerStmtId"
                 [href]="'/owner-stmt-preview/' + row.ownerStmtId" target="_blank"
                 style="color:#1565C0;text-decoration:underline">Statement</a>
            </td>
            <td>
              <span *ngIf="row._state === 'included'" style="color:green;font-weight:600">Added</span>
              <span *ngIf="row._state === 'excluded'" style="color:#777;font-weight:600">Excluded</span>
              <div *ngIf="row._error" style="color:red;font-size:0.8em;margin-bottom:4px">{{ row._error }}</div>
              <!-- Partial input mode -->
              <ng-container *ngIf="row._partialMode && !row._state">
                <input pInputText type="number" [(ngModel)]="row._partialAmount"
                       placeholder="Amount ($)" style="width:100px;margin-right:4px"
                       min="0.01" step="0.01" />
                <button pButton type="button" label="Add" icon="pi pi-check"
                        class="p-button-sm p-button-success" style="margin-right:4px"
                        [disabled]="row._inFlight" (click)="confirmPartialOx(row)"></button>
                <button pButton type="button" label="Cancel" icon="pi pi-times"
                        class="p-button-sm p-button-text"
                        [disabled]="row._inFlight" (click)="cancelPartialOx(row)"></button>
              </ng-container>
              <!-- Action buttons -->
              <ng-container *ngIf="!row._partialMode && !row._state">
                <button pButton type="button" label="Include" icon="pi pi-check"
                        class="p-button-sm p-button-success" style="margin-right:4px"
                        [disabled]="row._inFlight" (click)="includeOx(row)"></button>
                <button pButton type="button" label="Partial $" icon="pi pi-dollar"
                        class="p-button-sm p-button-warning" style="margin-right:4px"
                        [disabled]="row._inFlight" (click)="startPartialOx(row)"></button>
                <button pButton type="button" label="Exclude" icon="pi pi-ban"
                        class="p-button-sm p-button-danger"
                        [disabled]="row._inFlight" (click)="excludeOx(row)"></button>
              </ng-container>
            </td>
          </tr>
        </ng-container>
        <!-- Generic row for all other drill tiles -->
        <ng-container *ngIf="drillTileKey !== 'oxAwaiting'">
          <tr>
            <td *ngFor="let c of drillColumns">
              <ng-container *ngIf="c.field === '_orderLink'; else confLinkCell">
                <a *ngIf="row[c.field]" [routerLink]="row[c.field]" target="_blank"
                   style="color:#1a73e8;text-decoration:underline;cursor:pointer">View Order</a>
                <span *ngIf="!row[c.field]" style="color:#aaa">—</span>
              </ng-container>
              <ng-template #confLinkCell>
                <ng-container *ngIf="c.field === 'reservationConfId'; else plainCell">
                  <a *ngIf="row['_orderLink']" [routerLink]="row['_orderLink']" target="_blank"
                     style="color:#1a73e8;text-decoration:underline;cursor:pointer">{{ row[c.field] }}</a>
                  <span *ngIf="!row['_orderLink']">{{ row[c.field] }}</span>
                </ng-container>
              </ng-template>
              <ng-template #plainCell>{{ row[c.field] }}</ng-template>
            </td>
          </tr>
        </ng-container>
      </ng-template>
    </p-table>
  </div>
  <ng-template pTemplate="footer">
    <button *ngIf="drillTileKey === 'unlockedLedgers'" pButton type="button"
            label="Lock All in Period" icon="pi pi-lock"
            (click)="lockLedgersAction()" [disabled]="actionInFlight"></button>
    <button *ngIf="drillTileKey === 'expenseBlockers' && data && data.expenseBlockersNotReviewed > 0"
            pButton type="button" label="Bulk Set REVIEWED" icon="pi pi-check-square"
            (click)="bulkSetReviewedAction()" [disabled]="actionInFlight"></button>
    <button pButton type="button" label="Close" icon="pi pi-times"
            class="p-button-text" (click)="closeDrill()"></button>
  </ng-template>
</p-dialog>

<!-- NACHA Tools dialog — Tax (GET/TAT/MCTAT) + Owner Distribution (BoH ePay) -->
<app-nacha-tools-dialog
  [(visible)]="nachaDialogOpen"
  [month]="month"
  [year]="year">
</app-nacha-tools-dialog>
